import { create } from "zustand";

type SubscriptionStore = {
  isSubscriptionActive: boolean;
  isSubscriptionCancelled: boolean;
  setIsSubscriptionActive: (elem: boolean) => void;
  setIsSubscriptionCancelled: (elem: boolean) => void;
};

export const useSubscriptionStore = create<SubscriptionStore>((set) => ({
  isSubscriptionActive: true,
  isSubscriptionCancelled: false,

  setIsSubscriptionActive: (elem) =>
    set(() => ({
      isSubscriptionActive: elem,
    })),

  setIsSubscriptionCancelled: (elem) =>
    set(() => ({
      isSubscriptionCancelled: elem,
    })),
}));
